import { http } from "@/libs/util";
import util from "@/libs/util";

export const {
  sell_order_save,
  sell_order_query_mine,
  sell_order_es_query,
  sell_order_detail,
  sell_order_delete,
  sell_order_down_template_file,
  sell_order_down_import_items,
  sell_order_complete_order,
  // 发货通知
  sell_deliver_order_save,
  sell_deliver_order_delete,
  sell_deliver_order_detail,
  // 分销结算单
  sell_settlement_order_save,
  sell_settlement_es_query_mine,
  sell_settlement_es_query,
  sell_settlement_detail,
  sell_settlement_delete,
  sell_settlement_confirm,
  sell_settlement_order_export_items,
  // 合同
  contract_detail,
  // 外部库存
  third_party_mall_available_stock_num,
  // 查询收款单
  fin_receipt_bill_statement_match_search,
} = util.api || {};

export function getSellOrderSaveApi(params) {
  return http.post(sell_order_save, params);
}
export function getSellOrderQueryMineApi(params) {
  return http.get(sell_order_query_mine, params);
}
export function getSellOrderEsQueryApi(params) {
  return http.get(sell_order_es_query, params);
}
export function getSellOrderDetailApi(params) {
  return http.get(sell_order_detail, params);
}
export function sellOrderDeleteApi(params) {
  return http.post(sell_order_delete, params);
}
export function downloadTemplateFileApi() {
  return window.open(sell_order_down_template_file, '_blank')
}
export function postSellOrderDownImportItemsApi(params) {
  return http.post_upload(sell_order_down_import_items, params)
}

export function sellOrderCompleteOrderApi(params) {
  return http.post(sell_order_complete_order, params);
}

// 发货通知
export function getSellDeliverOrderSaveApi(params) {
  return http.post(sell_deliver_order_save, params);
}
export function sellDeliverOrderDeleteApi(params) {
  return http.post(sell_deliver_order_delete, params);
}
export function getSellDeliverOrderDetailApi(params) {
  return http.get(sell_deliver_order_detail, params);
}

// 分销结算单
export function sellSettlementOrderSaveApi(params) {
  return http.post(sell_settlement_order_save, params);
}
export function getSellSettlementEsQueryMineApi(params) {
  return http.get(sell_settlement_es_query_mine, params);
}
export function getSellSettlementEsQueryApi(params) {
  return http.get(sell_settlement_es_query, params);
}
export function getSellSettlementDetailApi(params) {
  return http.get(sell_settlement_detail, params);
}
export function sellSettlementDeleteApi(params) {
  return http.post(sell_settlement_delete, params);
}
export function sellSettlementConfirmApi(params) {
  return http.post(sell_settlement_confirm, params);
}
export function sellSettlementOrderExportItemsApi(params) {
  return window.open(sell_settlement_order_export_items + `?id=${params.id}`, '_blank')
}

// 合同
export function getContractDetailApi(params) {
  return http.get(contract_detail, params);
}

// 第三方查询库存
export function getThirdPartyMallAvailableStockNumApi(params) {
  return http.get(third_party_mall_available_stock_num, params);
}

// 查询收款单
export function finReceiptBillStatementMatchSearchApi(params) {
  return http.get(fin_receipt_bill_statement_match_search, params);
}
